import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let UserAvatarModelImpl = class UserAvatarModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = {};
    }
    updateUserAvatars(userAvatarSet) {
        this.update(() => {
            return {
                ...this._modelData,
                ...userAvatarSet,
            };
        });
    }
    getUserAvatarById(useId) {
        return this._modelData[useId];
    }
    dispose() {
        this.update(() => {
            return {};
        });
    }
};
UserAvatarModelImpl = __decorate([
    injectable()
], UserAvatarModelImpl);
export { UserAvatarModelImpl };
